<div>
    <div class="header-container">
        <div class="header-content">
            <h3>Notifications & Reminders</h3>
        </div>
    </div>
</div>
